export default function AccessibilityStatementPage() {
  return (
    <div
      className="px-4 md:px-5"
      style={{ direction: 'rtl', maxWidth: 900, margin: '0 auto', paddingTop: 40, paddingBottom: 40, fontFamily: 'sans-serif', lineHeight: 1.8, color: '#333' }}
    >
      <h1>הצהרת נגישות</h1>
      <p><strong>אחרון עודכן: מאי 2026</strong></p>

      <h2>1. מחויבותנו לנגישות</h2>
      <p>
        אנו רואים חשיבות רבה במתן שירות שוויוני לכלל הציבור, ופועלים להנגיש את האתר
        ואת השירותים הדיגיטליים שלנו לאנשים עם מוגבלות, בהתאם לחוק שוויון זכויות
        לאנשים עם מוגבלות, התשנ&quot;ח-1998 ולתקנות שוויון זכויות לאנשים עם מוגבלות
        (התאמות נגישות לשירות), התשע&quot;ג-2013.
      </p>

      <h2>2. רמת הנגישות באתר</h2>
      <p>
        האתר הונגש לרמת AA בהתאם לתקן הישראלי ת&quot;י 5568 המבוסס על הנחיות
        הנגישות לתכני אינטרנט <span dir="ltr">WCAG 2.0</span> של ארגון
        <span dir="ltr"> W3C</span>.
      </p>

      <h2>3. אמצעי הנגישות באתר</h2>
      <ul>
        <li>תפריט נגישות הזמין בכל עמוד (הסמל בפינת המסך) המאפשר: הגדלת והקטנת גודל הטקסט, ניגודיות גבוהה, מצב כהה, גווני אפור, הדגשת קישורים, גופן קריא, סמן גדול ועצירת אנימציות.</li>
        <li>האתר בנוי במבנה סמנטי המאפשר ניווט באמצעות מקלדת בלבד וקורא מסך.</li>
        <li>סימון מצב מיקוד (focus) ברור לניווט מקלדת.</li>
        <li>תמיכה בכיווניות עברית מימין לשמאל (<span dir="ltr">RTL</span>) והגדרת שפת המסמך.</li>
        <li>טקסט חלופי לתמונות בעלות משמעות.</li>
      </ul>

      <h2>4. החרגות ומגבלות ידועות</h2>
      <p>
        אנו עושים מאמץ מתמיד לשפר את נגישות האתר. ייתכן שחלקים מסוימים, ובפרט תכנים
        שנוצרו על ידי משתמשי המערכת (דפי קמפיין, טפסים ודיוורים) או רכיבי צד שלישי
        (כגון ממשק הסליקה), טרם הונגשו במלואם. אם נתקלתם בתוכן שאינו נגיש, נשמח שתפנו
        אלינו ונפעל לתקנו בהקדם.
      </p>

      <h2>5. דרכי פנייה ורכז הנגישות</h2>
      <p>
        בכל שאלה, בעיה או בקשה בנושא נגישות, ניתן לפנות אל רכז הנגישות שלנו:
      </p>
      <p>
        <strong>Y.Sh כלכלה וצריכה חברתית בע&quot;מ</strong> (ח.פ. 516866514)
        <br />
        רכז נגישות
        <br />
        עציון 27, פרדס חנה
        <br />
        טלפון: <a href="tel:0538286227">053-828-6227</a>
        <br />
        דוא&quot;ל: <a href="mailto:support@amutech.co.il">support@amutech.co.il</a>
      </p>
      <p>
        בעת פנייה נשמח אם תפרטו את הבעיה שנתקלתם בה, את העמוד שבו אירעה, וכן את סוג
        הדפדפן והטכנולוגיה המסייעת שבהם השתמשתם — פרטים אלו יסייעו לנו לטפל בפנייה
        במהירות וביעילות.
      </p>
    </div>
  );
}
